import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UserFormContainer from './UserFormContainer';

import classnames from 'classnames';

import './styles/user.scss';
import { getTitle } from 'state/tabs/tab/title';
import { getSettings } from 'state/settings';
import { getTabPreset, setPreset } from 'state/tabs/tab/preset/reducer';
import { setTokens } from 'state/tabs/tab/response/actions';
import {
  addSettings,
  deleteSettings,
  changeSettingsName,
} from 'state/settings/custom/reducer';
import { setDefaultPreset } from 'state/defaultPresets/reducer';
import { set as setNotification } from 'state/notification/actions';
import { logError } from '../../utils/splunkLog';
import adjustLUIStyle from '../../utils/adjustLUIStyle';
import settingsPlugin from '../../core/settingsPlugin';
import * as appSettingsActions from 'state/appSettings/actions';
import {setActiveUserInfo} from '../../state/selectedUser/actions';

export class UserContainer extends Component {
  state = {
    isUserShown: false,
    loggedin: false
  };
  userPopupRef = React.createRef();

  user = {};
  userCatalogInfo = {};

  componentDidMount() {
    this.signIn();

    document.addEventListener('click', this.onHidePopup, true);

    adjustLUIStyle(document.querySelectorAll('.rf-user lui-button') , 'lui-button');
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.onHidePopup, true);
  }

  signIn = async () => {
    const { settings, title, setTokens, setSettings } = this.props;
    let preset = '';
    for (let key in settings) {
      if (settings[key].type === "platformCredential" && settings[key].authEndpoint) {
        preset = key;
        break;
      }
    }
    const { type, authEndpoint,url } = settings[preset];
    // debugger
    try {
      const { getToken, getUserInfo, listProjects, getUserCatalogInfo } = settingsPlugin.get(type);
      const updatedSettings = await getToken(settings[preset], title, true);

      const info = await getUserInfo(updatedSettings.token);
      this.user = info;

      const { origin } = new URL(url);
      const userCatalogInfo = await getUserCatalogInfo(updatedSettings.token, origin);
      this.props.setActiveUserInfo(userCatalogInfo);
      this.userCatalogInfo = userCatalogInfo;
      setSettings({shareUrlCopyAs: false});
      this.setState({loggedin: true});
      
      listProjects(updatedSettings.token, authEndpoint).then( list => {
        updatedSettings.projectsList = list;
        setTokens(title, preset, updatedSettings);
      })
      setTokens(title, preset, updatedSettings);

    } catch (e) {
      logError(e);
    }
  }

  onHidePopup = (e) => {
    let popup = this.userPopupRef.current.getDomNode();
    if (!popup.contains(e.target) && this.state.isUserShown) {
      this.close();
    }
  };

  onClick = (e) => {
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
    this.setState({
      isUserShown: !this.state.isUserShown,
    });
  };

  closeOnEsc = (e) => {
    let keyCode = e.which || e.keyCode || 0;
    if (keyCode === 27) {
      this.close();
    }
  };

  close = () => {
    this.setState({
      isUserShown: false,
    });
  };

  render() {
    const {
      title,
      preset,
      settings,
      setPreset,
      addSettings,
      deleteSettings,
      changeSettingsName,
      setDefaultPreset,
      setNotification,
    } = this.props;
    const { loggedin } = this.state;
    const { given_name = '', family_name = '' } = this.user || {};

    const btnClassName = classnames('rf-user__btn', {
      'rf-user__btn_active': this.state.isUserShown,
      'rf-user__btn_loggedin': loggedin,
    });
    
    return (
      <div className="rf-user" onKeyDown={this.closeOnEsc}>
        <div className={btnClassName} onClick={this.onClick} >
        {loggedin && <span>{`${given_name.charAt(0)}${family_name.charAt(0)}`}</span>}
        </div>
        <UserFormContainer
          ref={this.userPopupRef}
          title={title}
          isUserShown={this.state.isUserShown}
          signIn={this.signIn}
          close={this.close}
          settings={settings}
          preset={preset}
          setPreset={setPreset}
          addSettings={addSettings}
          deleteSettings={deleteSettings}
          changeSettingsName={changeSettingsName}
          setDefaultPreset={setDefaultPreset}
          setNotification={setNotification}
          loggedin={loggedin}
          user={this.user}
          userCatalogInfo={this.userCatalogInfo}
        />
      </div>
    );
  }
}

UserContainer.propTypes = {
  title: PropTypes.string.isRequired,
  preset: PropTypes.string.isRequired,
  settings: PropTypes.object.isRequired,
  addSettings: PropTypes.func.isRequired,
  deleteSettings: PropTypes.func.isRequired,
  changeSettingsName: PropTypes.func.isRequired,
  setPreset: PropTypes.func.isRequired,
  setDefaultPreset: PropTypes.func.isRequired,
  setNotification: PropTypes.func.isRequired,
  setActiveUserInfo: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    title: getTitle(state),
    settings: getSettings(state),
    preset: getTabPreset(state),
    userInfo: state.activeUser.userInfo
  };
}

const mapDispatchToProps = {
  setPreset,
  addSettings,
  deleteSettings,
  changeSettingsName,
  setDefaultPreset,
  setNotification,
  setTokens,
  setSettings: appSettingsActions.setSettings,
  setActiveUserInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(UserContainer);
